import * as tslib_1 from "tslib";
import { Component } from "vue-property-decorator";
import RelevanceFormDropdown from "./relevance-form-dropdown.vue";
import RelevanceFormModal from "./relevance-form-modal.vue";
import { RelevanceFormControl } from "@cloudpivot/form/src/common/controls/relevance-form-control";
let RelevanceForm = class RelevanceForm extends RelevanceFormControl {
    onClick() {
        this.open();
    }
    created() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            //展示字段需取数据项列表中的relativePropertyCode;
            // let ls = await this.getRelativeDataList();
            // let dataModal: any = ls.find((c: any) => c.code === this.control.key);
            let dataModal = this.getDataItem(this.control.key, this.control.parentKey);
            if (!dataModal) {
                // 兼容列表查询条件没有传入DataItem。且查询条件只是存在主表；
                let ls = yield this.getRelativeDataList(true);
                dataModal = ls.find((c) => c.code === this.control.key);
            }
            //覆盖数据项options中的displayField（表单设计中的displayField，若在数据模型中重新定义一次后，会导致与后台的展示字段对应不上，所以直接拿后台的展示字段即可）
            if (dataModal.relativePropertyCode) {
                this.control.options.displayField = dataModal.relativePropertyCode;
            }
            else {
                let optionsJson = dataModal.options ? JSON.parse(dataModal.options) : '';
                if (optionsJson) {
                    this.control.options.displayField = optionsJson.displayField;
                }
                else {
                    this.control.options.displayField = "name";
                }
            }
        });
    }
};
RelevanceForm = tslib_1.__decorate([
    Component({
        name: "relevance-form",
        components: {
            RelevanceFormDropdown,
            RelevanceFormModal
        }
    })
], RelevanceForm);
export default RelevanceForm;
